var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __read = (this && this.__read) || function (o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
};
var __values = (this && this.__values) || function(o) {
    var s = typeof Symbol === "function" && Symbol.iterator, m = s && o[s], i = 0;
    if (m) return m.call(o);
    if (o && typeof o.length === "number") return {
        next: function () {
            if (o && i >= o.length) o = void 0;
            return { value: o && o[i++], done: !o };
        }
    };
    throw new TypeError(s ? "Object is not iterable." : "Symbol.iterator is not defined.");
};
import React, { useState, useEffect } from 'react';
import { FlightTextInput, FlightDropdown } from '@flybits/design-system';
import { getCtxCategoryFromString } from '../utils/helpers';
import { LOCATION_ATTRIBUTE_DISPLAY_NAMES, LOCATION_ATTRIBUTE_NAMES, LOCATION_ATTRIBUTE_UIDS, LOCATION_CATEGORY_DISPLAY_NAMES, LOCATION_PLUGIN_UIDS, } from '../constants/location';
var DropdownSearch = function (_a) {
    var _b;
    var className = _a.className, contextPlugins = _a.contextPlugins, onSelect = _a.onSelect, onCancel = _a.onCancel, uiBlocks = _a.uiBlocks;
    var DEFAULT_CLASS = 'dropdown-search';
    var DEFAULT_WIDTH = '470px';
    var _c = __read(useState((_b = {},
        _b[LOCATION_ATTRIBUTE_UIDS.APPROXIMATE_LIST] = false,
        _b[LOCATION_ATTRIBUTE_UIDS.PRECISE_LIST] = false,
        _b[LOCATION_ATTRIBUTE_UIDS.APPROXIMATE_LABELS] = false,
        _b[LOCATION_ATTRIBUTE_UIDS.PRECISE_LABELS] = false,
        _b)), 2), locationAttributePresentInUiBlock = _c[0], setLocationAttributePresentInUiBlock = _c[1];
    useEffect(function () {
        uiBlocks.forEach(function (uiBlock) {
            if (uiBlock.ctxAttributeUid && !locationAttributePresentInUiBlock[uiBlock.ctxAttributeUid]) {
                setLocationAttributePresentInUiBlock(function (prevState) {
                    var _a;
                    return (__assign(__assign({}, prevState), (_a = {}, _a[uiBlock.ctxAttributeUid] = true, _a)));
                });
            }
        });
    }, [uiBlocks]);
    var mapToDropdownItems = function () {
        var e_1, _a;
        // only handles ctx plugins rn
        var mappedItems = [];
        if (contextPlugins) {
            for (var contextPluginIdx = 0; contextPluginIdx < contextPlugins.length; contextPluginIdx++) {
                var contextPlugin = contextPlugins[contextPluginIdx];
                var isLocationPlugin = contextPlugin.uid === LOCATION_PLUGIN_UIDS.APPROXIMATE || contextPlugin.uid === LOCATION_PLUGIN_UIDS.PRECISE;
                var contextAttributes = [];
                for (var contextAttributeName in contextPlugin.values) {
                    contextAttributes.push({
                        name: contextAttributeName,
                        value: contextPlugin.values[contextAttributeName],
                    });
                }
                try {
                    for (var contextAttributes_1 = (e_1 = void 0, __values(contextAttributes)), contextAttributes_1_1 = contextAttributes_1.next(); !contextAttributes_1_1.done; contextAttributes_1_1 = contextAttributes_1.next()) {
                        var contextAttribute = contextAttributes_1_1.value;
                        var contextAttributeName = contextAttribute.name;
                        var contextAttributeValue = contextAttribute.value;
                        if (isLocationPlugin) {
                            if (locationAttributePresentInUiBlock[contextAttributeValue.uid]) {
                                continue;
                            }
                            var locationCategoryName = void 0;
                            if (contextPlugin.uid === LOCATION_PLUGIN_UIDS.APPROXIMATE) {
                                locationCategoryName = LOCATION_CATEGORY_DISPLAY_NAMES.APPROXIMATE;
                            }
                            if (contextPlugin.uid === LOCATION_PLUGIN_UIDS.PRECISE) {
                                locationCategoryName = LOCATION_CATEGORY_DISPLAY_NAMES.PRECISE;
                            }
                            var locationAttributeName = void 0;
                            if (contextAttributeName === LOCATION_ATTRIBUTE_NAMES.APPROXIMATE ||
                                contextAttributeName === LOCATION_ATTRIBUTE_NAMES.PRECISE) {
                                locationAttributeName = LOCATION_ATTRIBUTE_DISPLAY_NAMES.ADDRESS;
                            }
                            if (contextAttributeName === LOCATION_ATTRIBUTE_NAMES.LABELS) {
                                locationAttributeName = LOCATION_ATTRIBUTE_DISPLAY_NAMES.LABEL;
                            }
                            if (locationCategoryName && locationAttributeName) {
                                mappedItems.push({
                                    index: contextPluginIdx,
                                    value: "".concat(locationCategoryName, " / ").concat(locationAttributeName),
                                    type: 'plugin',
                                });
                            }
                        }
                        else {
                            mappedItems.push({
                                index: contextPluginIdx,
                                value: "".concat(contextPlugin.category || getCtxCategoryFromString(contextPlugin.uid), " / ").concat(contextAttributeName),
                                type: 'plugin',
                            });
                        }
                    }
                }
                catch (e_1_1) { e_1 = { error: e_1_1 }; }
                finally {
                    try {
                        if (contextAttributes_1_1 && !contextAttributes_1_1.done && (_a = contextAttributes_1.return)) _a.call(contextAttributes_1);
                    }
                    finally { if (e_1) throw e_1.error; }
                }
            }
        }
        return mappedItems.sort(function (a, b) {
            if (a.value < b.value)
                return -1;
            if (a.value > b.value)
                return 1;
            return 0;
        });
    };
    var renderItem = function (item, index) {
        var contextAttributeSegments = item.value.split('/');
        var isRule = item.type === 'rule';
        return (React.createElement("div", { className: "".concat(className ? className : DEFAULT_CLASS, "__dropdown-item\n        ").concat(item.isSelected ? 'is-selected' : ''), onClick: function () { return selectItem(item.index, contextAttributeSegments[0].trim(), contextAttributeSegments[1].trim()); }, key: index }, isRule ? null : (React.createElement(React.Fragment, null,
            contextAttributeSegments[0],
            "/ ",
            React.createElement("b", null, contextAttributeSegments[1])))));
    };
    var _d = __read(useState(''), 2), searchTerm = _d[0], setSearchTerm = _d[1];
    var _e = __read(useState(mapToDropdownItems()), 2), dropdownItems = _e[0], setDropdownItems = _e[1];
    var _f = __read(useState([]), 2), filteredItems = _f[0], setFilteredItems = _f[1];
    useEffect(function () {
        var filteredItems = dropdownItems.map(function (item, idx) {
            return __assign(__assign({}, item), { isSelected: idx === 0 });
        });
        setFilteredItems(filteredItems);
    }, [dropdownItems]);
    var selectItem = function (index, attrCategory, attrKey) {
        var contextAttribute = attrKey;
        if (contextAttribute === LOCATION_ATTRIBUTE_DISPLAY_NAMES.ADDRESS) {
            if (attrCategory === LOCATION_CATEGORY_DISPLAY_NAMES.APPROXIMATE) {
                contextAttribute = LOCATION_ATTRIBUTE_NAMES.APPROXIMATE;
            }
            if (attrCategory === LOCATION_CATEGORY_DISPLAY_NAMES.PRECISE) {
                contextAttribute = LOCATION_ATTRIBUTE_NAMES.PRECISE;
            }
        }
        if (contextAttribute === LOCATION_ATTRIBUTE_DISPLAY_NAMES.LABEL) {
            contextAttribute = LOCATION_ATTRIBUTE_NAMES.LABELS;
        }
        onSelect(contextPlugins[index], contextAttribute);
    };
    var handleKeyDown = function (event) {
        if (event.which === 13) {
            //enter
            var selected = filteredItems.find(function (item) {
                return item.isSelected === true;
            });
            if (selected && selected.type !== 'rule') {
                var selectedAttributeSegments = selected.value.split('/');
                selectItem(selected.index, selectedAttributeSegments[0].trim(), selectedAttributeSegments[1].trim());
            }
        }
        if (event.which === 38) {
            //up
            onArrowKey('up', event);
        }
        if (event.which === 40) {
            // down
            onArrowKey('down', event);
        }
    };
    var onArrowKey = function (direction, event) {
        event.preventDefault();
        if (filteredItems.length === 0)
            return;
        var selectedIdx = filteredItems.findIndex(function (item) {
            return item.isSelected === true;
        });
        var newIdx = direction === 'up' ? (selectedIdx - 1) % filteredItems.length : (selectedIdx + 1) % filteredItems.length;
        setFilteredItems(function (oldState) {
            return oldState.map(function (item, idx) {
                if (idx === selectedIdx)
                    return __assign(__assign({}, item), { isSelected: false });
                else if (idx === newIdx)
                    return __assign(__assign({}, item), { isSelected: true });
                else
                    return item;
            });
        });
    };
    var handleTermChange = function (value) {
        // this is not an ideal filtering function, and can be optimized to 1pass
        setFilteredItems(dropdownItems
            .filter(function (item) {
            return item.value.toLowerCase().includes(value.toLowerCase());
        })
            .map(function (item, idx) {
            return __assign(__assign({}, item), { isSelected: idx === 0 });
        }));
        setSearchTerm(value);
    };
    var onBlur = function (event) {
        var _a, _b;
        if (!((_b = (_a = event === null || event === void 0 ? void 0 : event.relatedTarget) === null || _a === void 0 ? void 0 : _a.classList) === null || _b === void 0 ? void 0 : _b.contains('flight-dropdown__dropdown'))) {
            onCancel();
        }
    };
    useEffect(function () {
        setDropdownItems(mapToDropdownItems());
    }, [contextPlugins, locationAttributePresentInUiBlock]);
    return (React.createElement("div", { className: "".concat(className ? className : DEFAULT_CLASS, "__search") },
        React.createElement(FlightDropdown, { className: "".concat(className ? className : DEFAULT_CLASS, "__dropdown"), trigger: React.createElement(FlightTextInput, { className: "".concat(className ? className : DEFAULT_CLASS, "__searchbar"), hasClearIcon: true, value: searchTerm, autoFocus: true, onChange: function (e) { return handleTermChange(e.target.value); }, onKeyDown: handleKeyDown, width: DEFAULT_WIDTH, onBlur: onBlur }), isActive: true, isControlledByIsActive: true, maxHeight: "300px" },
            React.createElement(React.Fragment, null, filteredItems.map(function (item, idx) { return renderItem(item, idx); })))));
};
export default DropdownSearch;
//# sourceMappingURL=DropdownSearch.js.map